/* LEKKO — interacciones propias (prefijo lk-) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(raiz) {
    var els = (raiz || document).querySelectorAll('.lk-reveal:not(.lk-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('lk-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('lk-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-lk-parallax]');
    if (!imgs.length || reducido) return;
    var pendiente = false;
    function mover() {
      imgs.forEach(function (img) {
        var k = parseFloat(img.getAttribute('data-lk-parallax')) || 0;
        var r = img.getBoundingClientRect();
        var centro = r.top + r.height / 2 - window.innerHeight / 2;
        img.style.translate = '0 ' + (centro * -k / 100).toFixed(1) + 'px';
      });
      pendiente = false;
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(mover); }
    }, { passive: true });
    mover();
  }

  function initAnatomia(raiz) {
    (raiz || document).querySelectorAll('[data-lk-anatomia]').forEach(function (sec) {
      var puntos = sec.querySelectorAll('[data-lk-punto]');
      var items = sec.querySelectorAll('[data-lk-item]');
      function activar(i) {
        puntos.forEach(function (p) { p.classList.toggle('lk-activo', p.getAttribute('data-lk-punto') === i); });
        items.forEach(function (it) { it.classList.toggle('lk-activo', it.getAttribute('data-lk-item') === i); });
      }
      puntos.forEach(function (p) {
        var i = p.getAttribute('data-lk-punto');
        p.addEventListener('mouseenter', function () { activar(i); });
        p.addEventListener('click', function () { activar(i); });
      });
      items.forEach(function (it) {
        var i = it.getAttribute('data-lk-item');
        it.addEventListener('mouseenter', function () { activar(i); });
        it.addEventListener('click', function () { activar(i); });
      });
      if (items.length) activar(items[0].getAttribute('data-lk-item'));
    });
  }

  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-lk-producto]').forEach(function (sec) {
      if (sec.dataset.lkListo) return;
      sec.dataset.lkListo = '1';

      // Galería
      var principal = sec.querySelector('[data-lk-principal]');
      sec.querySelectorAll('[data-lk-mini]').forEach(function (mini) {
        mini.addEventListener('click', function () {
          sec.querySelectorAll('[data-lk-mini]').forEach(function (m) { m.classList.remove('lk-activo'); });
          mini.classList.add('lk-activo');
          if (!principal) return;
          principal.classList.add('lk-cambiando');
          setTimeout(function () {
            principal.src = mini.getAttribute('data-src');
            principal.srcset = mini.getAttribute('data-srcset') || '';
            principal.alt = mini.getAttribute('data-alt') || '';
            principal.classList.remove('lk-cambiando');
          }, 200);
        });
      });

      // Cantidad
      var cant = sec.querySelector('[data-lk-cantidad]');
      sec.querySelectorAll('[data-lk-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          cant.value = Math.max(1, v + parseInt(b.getAttribute('data-lk-cant'), 10));
        });
      });

      // Variantes
      var datos = sec.querySelector('[data-lk-variantes]');
      var form = sec.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = sec.querySelector('[data-lk-anadir]');
      var precio = sec.querySelector('[data-lk-precio]');
      var tachado = sec.querySelector('[data-lk-tachado]');
      var ahorro = sec.querySelector('[data-lk-ahorro]');
      var textos = { anadir: boton ? boton.getAttribute('data-txt-anadir') : '', agotado: boton ? boton.getAttribute('data-txt-agotado') : '', nodisp: boton ? boton.getAttribute('data-txt-nodisp') : '' };
      var formato = sec.getAttribute('data-lk-moneda') || '{{amount_with_comma_separator}} €';

      function dinero(c) {
        var n = (c / 100).toFixed(2);
        var partes = n.split('.');
        var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return formato
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, miles + ',' + partes[1])
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0])
          .replace(/\{\{\s*amount\s*\}\}/, partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1]);
      }

      if (datos && inputId) {
        var variantes = JSON.parse(datos.textContent);
        sec.querySelectorAll('[data-lk-opcion] input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var elegidas = [];
            sec.querySelectorAll('[data-lk-opcion]').forEach(function (fs) {
              var c = fs.querySelector('input:checked');
              elegidas.push(c ? c.value : null);
            });
            var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
            if (!v) {
              boton.disabled = true; boton.querySelector('span').textContent = textos.nodisp; return;
            }
            inputId.value = v.id;
            boton.disabled = !v.available;
            boton.querySelector('span').textContent = v.available ? textos.anadir : textos.agotado;
            if (precio) precio.textContent = dinero(v.price);
            if (tachado) {
              var hay = v.compare_at_price && v.compare_at_price > v.price;
              tachado.textContent = hay ? dinero(v.compare_at_price) : '';
              tachado.hidden = !hay;
              if (ahorro) {
                ahorro.hidden = !hay;
                if (hay) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
              }
            }
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
            if (v.featured_media && principal) {
              var mini = sec.querySelector('[data-lk-mini][data-media-id="' + v.featured_media.id + '"]');
              if (mini) mini.click();
            }
          });
        });
      }

      // Añadir al carrito usando el cajón del carrito de Dawn si existe
      if (form) {
        form.addEventListener('submit', function (ev) {
          var cajon = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (!cajon || typeof cajon.renderContents !== 'function') return;
          ev.preventDefault();
          var error = sec.querySelector('[data-lk-error]');
          if (error) error.textContent = '';
          boton.disabled = true;
          var fd = new FormData(form);
          fd.append('sections', cajon.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
          fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            boton.disabled = false;
            if (res.status) { if (error) error.textContent = res.description || res.message; return; }
            if (cajon.classList.contains('is-empty')) cajon.classList.remove('is-empty');
            var vacio = cajon.querySelector('.drawer__inner-empty');
            if (vacio) vacio.remove();
            cajon.renderContents(res);
          }).catch(function () { boton.disabled = false; form.submit(); });
        });
      }
    });
  }

  function initHeroGiro(raiz) {
    if (reducido || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    (raiz || document).querySelectorAll(".lk-hp--animado .lk-hp__escena").forEach(function (escena) {
      var img = escena.querySelector(".lk-hp__img");
      if (!img || escena.dataset.lkGiro) return;
      escena.dataset.lkGiro = "1";
      escena.addEventListener("mousemove", function (e) {
        var r = escena.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        img.style.setProperty("--lk-ry", (x * 16).toFixed(2) + "deg");
        img.style.setProperty("--lk-rx", (y * -8).toFixed(2) + "deg");
      });
      escena.addEventListener("mouseleave", function () {
        img.style.setProperty("--lk-ry", "0deg");
        img.style.setProperty("--lk-rx", "0deg");
      });
    });
  }

  function initVentajas(raiz) {
    if (reducido) return;
    (raiz || document).querySelectorAll("[data-lk-ventajas]").forEach(function (sec) {
      sec.querySelectorAll(".lk-ven__icono svg > *").forEach(function (el) { el.setAttribute("pathLength", "1"); });
      sec.classList.add("lk-ven--dibujar");
    });
  }

  var pvCerrando = null;
  function pvAbrir() {
    var d = document.querySelector("[data-lk-preventa]");
    if (!d || typeof d.showModal !== "function") return;
    clearTimeout(pvCerrando);
    if (!d.open) d.showModal();
    document.documentElement.style.overflow = "hidden";
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add("lk-pv--abierto"); }); });
  }
  function pvCerrar() {
    var d = document.querySelector("[data-lk-preventa]");
    if (!d || !d.open) return;
    d.classList.remove("lk-pv--abierto");
    document.documentElement.style.overflow = "";
    pvCerrando = setTimeout(function () { d.close(); }, reducido ? 0 : 450);
  }
  function initPreventa() {
    if (document.documentElement.dataset.lkPv) return;
    document.documentElement.dataset.lkPv = "1";
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-lk-abrir-preventa]")) { e.preventDefault(); pvAbrir(); return; }
      if (e.target.closest("[data-lk-cerrar-preventa]")) { pvCerrar(); return; }
      var d = document.querySelector("[data-lk-preventa]");
      if (d && e.target === d) { pvCerrar(); return; }
      var cta = e.target.closest("[data-lk-pv-cta]");
      if (cta && new URL(cta.href, location.href).pathname === location.pathname) {
        e.preventDefault(); pvCerrar();
        var f = document.querySelector("[data-lk-producto] form");
        if (f) f.scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "center" });
      }
    });
    document.addEventListener("cancel", function (e) {
      if (e.target.matches && e.target.matches("[data-lk-preventa]")) { e.preventDefault(); pvCerrar(); }
    }, true);
    document.addEventListener("shopify:section:select", function (e) { if (e.target.querySelector("[data-lk-preventa]")) pvAbrir(); });
    document.addEventListener("shopify:section:deselect", function (e) { if (e.target.querySelector("[data-lk-preventa]")) pvCerrar(); });
  }

  function lkLeer(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lkGuardar(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function bvAbrir(d) {
    if (!d || d.open || typeof d.showModal !== "function") return;
    d.showModal();
    document.documentElement.style.overflow = "hidden";
    requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add("lk-bv--abierto"); }); });
    var num = d.querySelector("[data-lk-bv-num]");
    var fin = num ? parseInt(num.getAttribute("data-fin"), 10) : 0;
    if (num && fin > 0 && !reducido) {
      var t0 = null;
      num.textContent = "0";
      var paso = function (t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0 - 500) / 900);
        if (k > 0) num.textContent = Math.round(fin * (1 - Math.pow(1 - k, 3)));
        if (k < 1) requestAnimationFrame(paso);
      };
      requestAnimationFrame(paso);
    }
  }
  function bvCerrar(d, recordar) {
    if (!d || !d.open) return;
    d.classList.remove("lk-bv--abierto");
    document.documentElement.style.overflow = "";
    if (recordar) lkGuardar("lk_bv_cerrada", String(Date.now()));
    setTimeout(function () { d.close(); }, reducido ? 0 : 450);
  }
  function initBienvenida() {
    var d = document.querySelector("[data-lk-bienvenida]");
    if (!d || d.dataset.lkListo) return;
    d.dataset.lkListo = "1";
    d.addEventListener("click", function (e) {
      if (e.target === d || e.target.closest("[data-lk-cerrar-bienvenida]")) { bvCerrar(d, true); return; }
      var c = e.target.closest("[data-lk-copiar]");
      if (c) {
        var txt = c.getAttribute("data-lk-copiar");
        if (navigator.clipboard) navigator.clipboard.writeText(txt).catch(function () {});
        c.textContent = c.getAttribute("data-txt-ok") || "OK"; c.classList.add("lk-copiado");
      }
    });
    d.addEventListener("cancel", function (e) { e.preventDefault(); bvCerrar(d, true); });
    document.addEventListener("shopify:section:select", function (e) { if (e.target.contains(d)) bvAbrir(d); });
    document.addEventListener("shopify:section:deselect", function (e) { if (e.target.contains(d)) bvCerrar(d, false); });

    // Tras enviar el formulario: abrir directamente con el código o con el error
    if (d.querySelector("[data-lk-bv-ok]")) { lkGuardar("lk_bv_suscrita", "1"); bvAbrir(d); return; }
    if (d.querySelector("[data-lk-bv-error]")) { bvAbrir(d); return; }
    if (window.Shopify && window.Shopify.designMode) return;
    if (lkLeer("lk_bv_suscrita")) return;
    var cerrada = parseInt(lkLeer("lk_bv_cerrada") || "0", 10);
    var dias = parseInt(d.getAttribute("data-dias") || "7", 10);
    if (cerrada && Date.now() - cerrada < dias * 864e5) return;

    var lanzada = false;
    var lanzar = function () {
      if (lanzada) return;
      var pv = document.querySelector("[data-lk-preventa]");
      var idi = document.querySelector("[data-lk-idioma-popup]");
      if ((pv && pv.open) || (idi && (idi.open || !lkLeer("lk_idioma"))) || document.querySelector("cart-drawer.active")) { setTimeout(lanzar, 4000); return; }
      lanzada = true; bvAbrir(d);
    };
    setTimeout(lanzar, parseInt(d.getAttribute("data-retraso") || "6", 10) * 1000);
    // Si va a salir de la página (ordenador), mostrarla antes
    document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY <= 0) lanzar(); });
  }

  function initColores(raiz) {
    (raiz || document).querySelectorAll("[data-lk-colores]").forEach(function (sec) {
      if (sec.dataset.lkListo) return;
      sec.dataset.lkListo = "1";
      var pista = sec.querySelector("[data-lk-col-pista]");
      var slides = Array.prototype.slice.call(sec.querySelectorAll("[data-lk-col-slide]"));
      var muestras = Array.prototype.slice.call(sec.querySelectorAll("[data-lk-col-ir]"));
      var prev = sec.querySelector("[data-lk-col-prev]"), next = sec.querySelector("[data-lk-col-next]");
      if (!pista || !slides.length) return;
      var actual = 0;
      function marcar(i) {
        actual = i;
        slides.forEach(function (s, k) { s.classList.toggle("lk-activo", k === i); });
        muestras.forEach(function (m, k) { m.classList.toggle("lk-activo", k === i); m.setAttribute("aria-selected", k === i ? "true" : "false"); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }
      function ir(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        var s = slides[i];
        pista.scrollTo({ left: s.offsetLeft - (pista.clientWidth - s.clientWidth) / 2, behavior: reducido ? "auto" : "smooth" });
        marcar(i);
      }
      var calc = null;
      pista.addEventListener("scroll", function () {
        clearTimeout(calc);
        calc = setTimeout(function () {
          var centro = pista.scrollLeft + pista.clientWidth / 2, mejor = 0, dist = Infinity;
          slides.forEach(function (s, k) { var d = Math.abs(s.offsetLeft + s.clientWidth / 2 - centro); if (d < dist) { dist = d; mejor = k; } });
          if (mejor !== actual) marcar(mejor);
        }, 60);
      }, { passive: true });
      if (prev) prev.addEventListener("click", function () { ir(actual - 1); });
      if (next) next.addEventListener("click", function () { ir(actual + 1); });
      muestras.forEach(function (m) { m.addEventListener("click", function () { ir(parseInt(m.getAttribute("data-lk-col-ir"), 10)); }); });
      slides.forEach(function (s, k) { s.addEventListener("click", function (e) { if (k !== actual && !e.target.closest("a")) { e.preventDefault(); ir(k); } }); });
      pista.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") { e.preventDefault(); ir(actual + 1); }
        if (e.key === "ArrowLeft") { e.preventDefault(); ir(actual - 1); }
      });
      marcar(0);
    });
  }

  function initProx(raiz) {
    (raiz || document).querySelectorAll("[data-lk-prox]").forEach(function (sec) {
      if (sec.dataset.lkListo) return;
      sec.dataset.lkListo = "1";
      if (!reducido) {
        sec.querySelectorAll(".lk-prox__icono svg > *").forEach(function (el) { el.setAttribute("pathLength", "1"); });
        sec.classList.add("lk-prox--dibujar");
      }
      var b = sec.querySelector("[data-lk-prox-boton]");
      if (!b) return;
      b.addEventListener("click", function () {
        var abrir = !sec.classList.contains("lk-prox--abierto");
        sec.classList.toggle("lk-prox--abierto", abrir);
        b.setAttribute("aria-expanded", abrir ? "true" : "false");
        if (abrir) setTimeout(function () {
          var panel = sec.querySelector("[data-lk-prox-panel]");
          if (panel) panel.scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "nearest" });
        }, 450);
      });
    });
    if (!document.documentElement.dataset.lkBvBoton) {
      document.documentElement.dataset.lkBvBoton = "1";
      document.addEventListener("click", function (e) {
        if (!e.target.closest("[data-lk-abrir-bienvenida]")) return;
        var d = document.querySelector("[data-lk-bienvenida]");
        if (d) { e.preventDefault(); bvAbrir(d); }
      });
    }
  }

  function initIdiomaPopup() {
    var d = document.querySelector("[data-lk-idioma-popup]");
    if (!d || d.dataset.lkListo) return;
    d.dataset.lkListo = "1";
    var actual = (document.documentElement.lang || "es").slice(0, 2);
    var abrir = function () {
      if (d.open || typeof d.showModal !== "function") return;
      var nav = (navigator.language || "es").slice(0, 2);
      d.querySelectorAll("[data-lk-lang]").forEach(function (b) { b.classList.toggle("lk-sugerido", b.getAttribute("data-lk-lang") === nav); });
      d.showModal(); document.documentElement.style.overflow = "hidden";
      requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add("lk-lang--abierto"); }); });
    };
    var cerrar = function () {
      d.classList.remove("lk-lang--abierto"); document.documentElement.style.overflow = "";
      setTimeout(function () { if (d.open) d.close(); }, reducido ? 0 : 400);
    };
    d.addEventListener("click", function (e) {
      var b = e.target.closest("[data-lk-lang]");
      if (b) {
        var code = b.getAttribute("data-lk-lang");
        lkGuardar("lk_idioma", code);
        if (code === actual) { e.preventDefault(); cerrar(); }
        return;
      }
      if (e.target === d) { lkGuardar("lk_idioma", actual); cerrar(); }
    });
    d.addEventListener("cancel", function (e) { e.preventDefault(); lkGuardar("lk_idioma", actual); cerrar(); });
    document.addEventListener("shopify:section:select", function (e) { if (e.target.contains(d)) abrir(); });
    document.addEventListener("shopify:section:deselect", function (e) { if (e.target.contains(d)) cerrar(); });
    // Si ya cambia de idioma desde el pie, también cuenta como elegido
    document.addEventListener("click", function (e) { var o = e.target.closest(".lk-idioma__op"); if (o) lkGuardar("lk_idioma", o.value || actual); });
    if (window.Shopify && window.Shopify.designMode) return;
    if (lkLeer("lk_idioma")) return;
    setTimeout(abrir, 700);
  }

  function iniciar(raiz) {
    initIdiomaPopup();
    initProx(raiz);
    initColores(raiz);
    initBienvenida();
    initPreventa();
    initVentajas(raiz);
    initHeroGiro(raiz);
    initReveal(raiz);
    initAnatomia(raiz);
    initProducto(raiz);
  }

  document.addEventListener('DOMContentLoaded', function () { iniciar(); initParallax(); });
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
